/* shah */
import React from 'react'

const HighlightHoverIcon = () => {
    return (
        <svg id="SmallBoxSVG-search" version="1.0" xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512.000000 512.000000"
            preserveAspectRatio="xMidYMid meet">

            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
            >
                <path d="M130 5104 c-45 -20 -87 -59 -111 -106 -18 -35 -19 -63 -19 -407 l0
-370 26 -20 c35 -28 67 -26 101 3 l28 24 3 350 c3 338 4 350 24 368 19 18 67
19 1259 22 l1239 2 0 -385 c0 -360 1 -388 19 -423 23 -44 62 -82 111 -108 32
-17 67 -19 418 -22 l382 -3 0 -223 0 -223 -53 18 c-28 10 -97 28 -152 40 -99
23 -108 23 -1025 26 l-926 4 -27 -21 c-34 -27 -38 -89 -7 -120 19 -19 33 -20
552 -20 l532 0 -90 -59 c-49 -32 -113 -80 -141 -105 l-51 -46 -391 0 c-378 0
-392 -1 -411 -20 -31 -31 -27 -93 6 -119 26 -20 38 -21 339 -21 l313 0 -45
-67 c-79 -118 -145 -270 -183 -420 l-11 -43 -197 0 c-231 0 -242 -3 -242 -74
0 -76 12 -81 229 -84 l186 -3 0 -100 0 -99 -181 0 c-168 0 -183 -1 -208 -21
-33 -26 -37 -88 -6 -119 19 -19 33 -20 218 -20 l199 0 13 -57 c31 -141 101
-303 183 -426 l45 -67 -313 0 c-301 0 -313 -1 -339 -21 -33 -26 -37 -88 -6
-119 19 -19 33 -20 410 -20 l391 0 67 -57 c36 -31 100 -78 142 -105 l75 -48
-533 0 c-519 0 -533 -1 -552 -20 -28 -28 -27 -90 1 -116 20 -18 50 -19 943
-19 1006 0 981 -1 1173 60 l74 23 -3 -449 -3 -448 -23 -23 -23 -23 -1678 0
c-1637 0 -1679 0 -1700 19 l-21 19 0 1882 c0 1348 -3 1891 -11 1914 -6 17 -19
36 -29 41 -31 16 -79 11 -100 -10 -20 -20 -20 -33 -20 -1937 0 -1846 1 -1920
19 -1958 23 -49 64 -89 113 -109 33 -14 225 -16 1753 -16 1559 0 1719 1 1748
16 45 23 85 62 110 109 22 39 22 50 25 542 l3 502 46 26 46 27 84 -84 c83 -83
83 -84 72 -116 -8 -25 -8 -40 1 -61 6 -16 127 -144 269 -285 308 -305 317
-311 476 -311 87 0 107 3 156 26 69 33 129 91 166 161 26 49 28 62 28 163 0
162 2 159 -314 477 -275 278 -300 297 -348 269 -15 -8 -31 3 -105 76 l-86 86
48 91 c81 152 129 303 150 474 13 115 -6 152 -79 152 -21 0 -71 -30 -71 -43 0
-35 -26 -192 -42 -252 -90 -344 -356 -648 -681 -781 -240 -97 -485 -115 -731
-53 -387 98 -705 396 -825 774 -75 235 -74 497 3 723 110 323 360 588 671 713
426 170 899 80 1231 -234 180 -171 278 -337 339 -577 28 -111 48 -135 105
-126 52 8 73 40 66 98 -18 135 -108 358 -200 496 -95 143 -225 271 -381 374
l-90 60 -5 319 -5 319 -485 485 -485 485 -1315 0 c-1152 -1 -1319 -3 -1350
-16z m3278 -912 c-46 -2 -183 -2 -304 0 -202 3 -224 5 -243 22 -20 19 -21 27
-21 325 l0 306 325 -325 325 -325 -82 -3z m832 -2787 l75 -75 -83 -83 -82 -82
-77 77 -77 77 79 80 c44 45 82 81 85 81 3 0 39 -34 80 -75z m472 -352 c118
-120 223 -232 232 -250 20 -39 21 -122 2 -166 -17 -39 -71 -92 -109 -106 -36
-14 -108 -14 -144 -1 -15 6 -130 113 -255 238 l-228 227 137 137 c76 76 140
138 143 138 3 0 103 -98 222 -217z"/>
                <path d="M620 3733 c-36 -14 -72 -47 -90 -83 -18 -35 -20 -60 -20 -245 0 -231
7 -260 72 -307 32 -22 41 -23 258 -26 222 -3 226 -3 260 20 19 13 45 39 57 57
22 33 23 42 23 256 0 214 -1 223 -22 255 -51 74 -55 75 -301 77 -122 1 -229
-1 -237 -4z m400 -328 l0 -175 -175 0 -175 0 0 175 0 175 175 0 175 0 0 -175z"/>
                <path d="M2995 3313 c-416 -58 -765 -405 -826 -824 -24 -165 6 -424 56 -479
25 -28 88 -27 116 1 23 23 23 40 -5 174 -62 288 54 603 291 793 85 69 153 105
263 144 91 31 102 32 245 33 171 0 226 -12 360 -76 472 -226 614 -833 292
-1245 -87 -110 -214 -207 -340 -257 -172 -69 -385 -76 -557 -18 -149 50 -272
132 -371 248 -51 59 -81 76 -120 68 -36 -8 -59 -39 -59 -80 0 -73 194 -251
365 -335 158 -78 237 -95 440 -94 142 0 183 4 248 22 335 93 590 342 694 679
25 82 27 100 27 273 0 174 -2 191 -27 274 -109 353 -391 615 -740 687 -87 18
-266 24 -352 12z"/>
                <path d="M3395 2761 c-57 -14 -91 -40 -214 -165 l-124 -126 -36 29 c-77 61
-139 78 -220 60 -109 -23 -182 -114 -182 -227 -1 -94 21 -130 168 -274 144
-142 186 -167 274 -168 95 0 132 28 374 278 234 240 254 270 255 363 0 154
-144 266 -295 230z m88 -163 c32 -16 46 -39 47 -71 0 -24 -34 -64 -202 -235
-111 -114 -211 -215 -222 -224 -46 -38 -69 -26 -202 104 -110 107 -124 125
-124 155 0 50 37 81 89 73 8 -1 48 -31 88 -66 111 -97 104 -99 298 100 178
183 184 188 228 164z"/>
                <path d="M626 2680 c-37 -12 -85 -56 -102 -97 -20 -46 -20 -420 0 -466 18 -43
67 -84 118 -97 25 -7 114 -10 232 -8 180 3 193 4 229 27 21 12 47 41 58 63 19
36 20 55 17 261 -3 216 -4 223 -27 256 -45 62 -81 71 -301 70 -107 0 -208 -5
-224 -9z m392 -327 l-3 -178 -170 0 -170 0 -3 165 c-1 90 0 170 2 177 4 10 46
13 176 13 l170 0 -2 -177z"/>
                <path d="M604 1596 c-17 -8 -44 -31 -60 -52 l-29 -37 -3 -221 c-2 -214 -2
-222 21 -261 12 -22 40 -50 62 -62 39 -23 47 -23 262 -21 246 3 250 4 300 78
22 32 23 41 23 255 0 214 -1 223 -23 256 -12 18 -38 44 -56 56 -33 22 -42 23
-250 23 -159 -1 -224 -4 -247 -14z m416 -321 l0 -175 -175 0 -175 0 0 175 0
175 175 0 175 0 0 -175z"/>
            </g>
        </svg>

    )
}

export default HighlightHoverIcon